import React, { useState } from 'react';
import { FaCheck } from 'react-icons/fa';

export function VoteModal({ voting, onClose, onVote, voting_in_progress }) {
  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleToggleOption = (optionId) => {
    if (voting.vote_type === 'single_choice' || voting.vote_type === 'yes_no') {
      setSelectedOptions([optionId]);
    } else {
      setSelectedOptions(prev =>
        prev.includes(optionId)
          ? prev.filter(id => id !== optionId)
          : [...prev, optionId]
      );
    }
  };

  const handleSubmit = () => {
    if (selectedOptions.length === 0) {
      alert('Please select at least one option');
      return;
    }
    onVote(voting.voting_id, selectedOptions);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center px-4 z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6" data-testid="vote-modal">
        <h3 className="text-xl font-bold text-gray-800 mb-2">{voting.title}</h3>
        {voting.description && (
          <p className="text-gray-600 mb-4">{voting.description}</p>
        )}

        <p className="text-sm text-gray-500 mb-4">
          {voting.vote_type === 'multiple_choice'
            ? 'Select all that apply'
            : 'Select one option'}
        </p>

        <div className="space-y-2 mb-6">
          {voting.options.map((opt) => (
            <button
              key={opt.option_id}
              onClick={() => handleToggleOption(opt.option_id)}
              className={`w-full p-3 rounded-lg border-2 text-left transition ${
                selectedOptions.includes(opt.option_id)
                  ? 'border-blue-600 bg-blue-50'
                  : 'border-gray-200 hover:border-gray-300'
              }`}
              data-testid={`vote-option-${opt.option_id}`}
            >
              <div className="flex items-center">
                <div className={`w-5 h-5 rounded-full border-2 mr-3 flex items-center justify-center ${
                  selectedOptions.includes(opt.option_id)
                    ? 'border-blue-600 bg-blue-600'
                    : 'border-gray-300'
                }`}>
                  {selectedOptions.includes(opt.option_id) && (
                    <FaCheck className="text-white text-xs" />
                  )}
                </div>
                <span className="font-medium">{opt.text}</span>
              </div>
            </button>
          ))}
        </div>

        <div className="flex space-x-3">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={selectedOptions.length === 0 || voting_in_progress}
            className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
            data-testid="submit-vote-btn"
          >
            {voting_in_progress ? 'Submitting...' : 'Submit Vote'}
          </button>
        </div>
      </div>
    </div>
  );
}
